module.exports = require("core-js/modules/es.symbol.to-string-tag.js");